import useCategoryApi from "views/Catalog/Categories/hooks/useCategoryApi";
import useNotification from "utils/hooks/useNotification";
import { useTranslation } from "react-i18next";
import { Modal } from "antd";
import { FaArchive } from "react-icons/fa";
import TooltipButton from "views/Documents/components/TooltipButton";

interface RemoveButtonPropsTypes {
  id?: ID;
  refetch?: () => void;
}

export default function ArchiveButton({ id, refetch }: RemoveButtonPropsTypes) {
  const { t } = useTranslation();
  const { archiveCompanyPaymentDeadline } = useCategoryApi();
  const { notificationError } = useNotification();

  const confirmArchive = (id: ID) => {
    Modal.confirm({
      title: t("Archive payment date limit"),
      content: t("Are you sure you want to archive this deadline ?"),
      okText: t("Yes"),
      okType: "danger",
      onOk: () => handleOk(id),
    });
  };

  const handleOk = async (id: ID) => {
    const response = await archiveCompanyPaymentDeadline({
      variables: {
        id,
      },
    });

    const errors = response?.data?.archiveCompanyPaymentDeadline.errors;
    notificationError(errors);
    refetch!();
  };

  return (
    <TooltipButton
      title={t("Archive")}
      placement="top"
      handleOnClick={() => confirmArchive(id)}
      icon={<FaArchive />}
    />
  );
}
